/** @jsxImportSource @emotion/react */
import { Paper } from '@mui/material';
import BigNumber from 'bignumber.js';
import React from 'react';
import { Asset, Vault } from 'types';

import { useStyles as useSharedStyles } from '../styles';
import SupplyMarket from './SupplyMarket';
import { useStyles as useLocalStyles } from './styles';

export interface MarketsProps {
  isXvsEnabled: boolean;
  accountAddress: string;
  userTotalBorrowLimitCents: BigNumber;
  suppliedAssets: Asset[];
  supplyMarketAssets: Asset[];
  borrowingAssets: Asset[];
  borrowMarketAssets: Asset[];
  vaults: Vault[];
}

const Markets: React.FC<MarketsProps> = ({
  isXvsEnabled,
  accountAddress,
  userTotalBorrowLimitCents,
  suppliedAssets,
  supplyMarketAssets,
  borrowingAssets,
  borrowMarketAssets,
                                           vaults,
}) => {
  const sharedStyles = useSharedStyles();
  const localStyles = useLocalStyles();
  const styles = {
    ...sharedStyles,
    ...localStyles,
  };

  return (
    <>
      {/* Desktop display */}
      <div css={[styles.row, styles.desktopViewContainer]}>
        <SupplyMarket
          css={styles.column}
          isXvsEnabled={isXvsEnabled}
          suppliedAssets={suppliedAssets}
          supplyMarketAssets={supplyMarketAssets}
          accountAddress={accountAddress}
          vaults={vaults}
        />

        {/* <BorrowMarket */}
        {/*   css={styles.column} */}
        {/*   isXvsEnabled={isXvsEnabled} */}
        {/*   borrowingAssets={borrowingAssets} */}
        {/*   borrowMarketAssets={borrowMarketAssets} */}
        {/*   userTotalBorrowLimitCents={userTotalBorrowLimitCents} */}
        {/* /> */}
      </div>

      {/* Tablet view */}
      <Paper css={styles.tabletViewContainer}>
        <SupplyMarket
          isXvsEnabled={isXvsEnabled}
          suppliedAssets={suppliedAssets}
          supplyMarketAssets={supplyMarketAssets}
          accountAddress={accountAddress}
          vaults={vaults}
        />
      </Paper>

      {/* Mobile display */}
      <Paper css={styles.mobileViewContainer}>
        <SupplyMarket
          isXvsEnabled={isXvsEnabled}
          suppliedAssets={suppliedAssets}
          supplyMarketAssets={supplyMarketAssets}
          accountAddress={accountAddress}
          vaults={vaults}
        />
      </Paper>
    </>
  );
};

export default Markets;
